/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
(function($) {
  $(".announcement-items").slick({
    dots: false,
    fade: true,
    cssEase: 'linear',
    autoplay: true,
    arrows: false
  });
  
  
  // $(".announcement-items").on('init', function() {
  //   $(".announcement-items").css("visibility", "visible");
  // });
})(jQuery);
